import React, { useState, useEffect } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import InstallAppModal from './InstallAppModal';

/**
 * InstallAppPrompt Component
 *
 * Manages the PWA install prompt flow.
 * Shows the install modal after the tutorial is completed or skipped.
 */
function InstallAppPrompt() {
  const [showModal, setShowModal] = useState(false);
  const {
    canShowInstallPrompt,
    isIOSSafari,
    promptInstall,
    dismissInstall,
  } = usePWAInstall();

  useEffect(() => {
    const handleTutorialEnded = () => {
      // Small delay to let tutorial modal close first
      setTimeout(() => {
        if (canShowInstallPrompt) {
          setShowModal(true);
        }
      }, 500);
    };

    window.addEventListener('tutorialEnded', handleTutorialEnded);

    return () => {
      window.removeEventListener('tutorialEnded', handleTutorialEnded);
    };
  }, [canShowInstallPrompt]);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDismiss = () => {
    dismissInstall(true); // Permanently dismiss
    setShowModal(false);
  };

  const handleInstall = async () => {
    const accepted = await promptInstall();
    if (accepted) {
      setShowModal(false);
    }
    return accepted;
  };

  return (
    <InstallAppModal
      isOpen={showModal}
      onClose={handleClose}
      onDismiss={handleDismiss}
      onInstall={handleInstall}
      isIOSSafari={isIOSSafari}
    />
  );
}

export default InstallAppPrompt;
